module.exports = __webpack_public_path__ + "static/media/my_transactions_icon_active.e29e83fb.svg";